import { gql } from '@apollo/client';

export const promotionDetails = gql`
  fragment promotionDetails on Promotion {
    id
    title
    benefits {
      benefitType
      duration
      subBenefitType
      iterations
      value
      scale
      type
      customisable {
        value {
          type
          lowerBound
          upperBound
        }
        iterations {
          type
          lowerBound
          upperBound
        }
        duration
      }
    }
    promotionWindow {
      endTime
      startTime
    }
    status
    cycleInterval
    pricingType
    eligibilityRules {
      products
      cycleInterval
      pricingType
      partnerType
      partnerTier
      saleTransitionType
      currency
    }
    applicationReason {
      id
      readableName
      customisable {
        id {
          type
          anyOf {
            readableName
            id
          }
        }
      }
    }
    customisableReasons {
      readableName
      id
    }
    isPromotionCustomisable
    type
  }
`;

export const fetchAvailablePromotionsForEntitlementQuery = gql`
  ${promotionDetails}
  query fetchAvailablePromotionsForEntitlement($id: String, $intendedBillingPeriodState: String) {
    entitlementDetails(id: $id) {
      id
      subscriptionId
      billingFrequency: billingCycle
      productId
      edition
      availablePromotions(intendedBillingPeriodState: $intendedBillingPeriodState) {
        ...promotionDetails
      }
    }
  }
`;
